import Vue from 'vue'
import Router from 'vue-router'
import Session from '@/utils/Session.js'
import WxJs from '@/utils/WxJs.js'
import Global from '@/utils/Global.js'
import Axios from '@/utils/Axios.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { meta: { shareEnabled: true }, path: '/error', name: 'error', component: () => import('@/views/error') },
    { meta: { shareEnabled: true }, path: '/demo', name: 'demo', component: () => import('@/views/_demo/index') },
    { meta: { shareEnabled: true }, path: '/demo/demo1', name: 'demo1', component: () => import('@/views/_demo/demo1') },
    { meta: { shareEnabled: true }, path: '/demo/demo2', name: 'demo2', component: () => import('@/views/_demo/demo2') },
    { meta: { shareEnabled: true }, path: '/demo/demoPage1', name: 'demoPage1', component: () => import('@/views/_demo/demoPage1') },
    { meta: { shareEnabled: true }, path: '/demo/demoPage2', name: 'demoPage2', component: () => import('@/views/_demo/demoPage2') },
    { meta: { shareEnabled: true }, path: '/demo/demoPage3', name: 'demoPage3', component: () => import('@/views/_demo/demoPage3') },
    { meta: { shareEnabled: true }, path: '/', redirect: '/index' },
    /* 商城 */
    {
      path: '/index', redirect: '/shop/index', component: () => import('@/views/shop/main'), children: [
        { meta: { shareEnabled: true }, path: '/index', redirect: '/shop/index' },
        { meta: { shareEnabled: true }, path: '/shop/index', name: 'shopIndex', component: () => import('@/views/shop/index') },
        // 栏目
        { meta: { shareEnabled: true }, path: '/shop/column/columnResList', name: 'columnResList', component: () => import('@/views/shop/column/columnResList') },
        // 资源
        { meta: { shareEnabled: true }, path: '/shop/res/resList', name: 'resList', component: () => import('@/views/shop/res/resList') },
        { meta: { shareEnabled: false }, path: '/shop/res/resDetail', name: 'resDetail', component: () => import('@/views/shop/res/resDetail') },
        // 团购
        { meta: { shareEnabled: true }, path: '/shop/teamBuy/teamBuyTypeList', name: 'teamBuyTypeList', component: () => import('@/views/shop/teamBuy/teamBuyTypeList') },
        { meta: { shareEnabled: true }, path: '/shop/teamBuy/teamBuyTypeDetail', name: 'teamBuyTypeDetail', component: () => import('@/views/shop/teamBuy/teamBuyTypeDetail') },
        // 个人中心
        { meta: { shareEnabled: true }, path: '/shop/userCenter/index', name: 'userCenter', component: () => import('@/views/shop/userCenter/index') },
        // 个人中心 - 订单
        { meta: { shareEnabled: true }, path: '/shop/userCenter/order/orderList', name: 'orderList', component: () => import('@/views/shop/userCenter/order/orderList') },
        { meta: { shareEnabled: true }, path: '/shop/userCenter/order/orderDetail', name: 'orderDetail', component: () => import('@/views/shop/userCenter/order/orderDetail') },
        // 个人中心 - 优惠券
        { meta: { shareEnabled: true }, path: '/shop/userCenter/coupon/couponList', name: 'couponList', component: () => import('@/views/shop/userCenter/coupon/couponList') },
        { meta: { shareEnabled: true }, path: '/shop/userCenter/coupon/couponReceive', name: 'couponReceive', component: () => import('@/views/shop/userCenter/coupon/couponReceive') },
        // 个人中心 - VIP充值
        { meta: { shareEnabled: true }, path: '/shop/userCenter/recharge', name: 'rechargeIndex', component: () => import('@/views/shop/userCenter/recharge/index') },
        { meta: { shareEnabled: true }, path: '/shop/userCenter/recharge/pay', name: 'rechargePay', component: () => import('@/views/shop/userCenter/recharge/pay') },
        { meta: { shareEnabled: true }, path: '/shop/userCenter/recharge/pay2', name: 'rechargePay2', component: () => import('@/views/shop/userCenter/recharge/pay2') },
        // 个人中心 - 积分
        { meta: { shareEnabled: true }, path: '/shop/userCenter/wheat/wheatRecord', name: 'wheatRecord', component: () => import('@/views/shop/userCenter/wheat/wheatRecord') },
        { meta: { shareEnabled: true }, path: '/shop/userCenter/wheat/wheatReceive', name: 'wheatReceive', component: () => import('@/views/shop/userCenter/wheat/wheatReceive') },
        // 个人中心 - 我的任务
        { meta: { shareEnabled: true }, path: '/shop/userCenter/task/index', name: 'userTask', component: () => import('@/views/shop/userCenter/task/index') },
        // 个人中心 - 收藏
        { meta: { shareEnabled: true }, path: '/shop/userCenter/favorites/index', name: 'favoritesIndex', component: () => import('@/views/shop/userCenter/favorites/index') },
        // 个人中心 - 积分商城
        { meta: { shareEnabled: true }, path: '/shop/wheatShop/index', name: 'wheatShopIndex', component: () => import('@/views/shop/wheatShop/index') },
        // 资料库
        { meta: { shareEnabled: true }, path: '/shop/lib/index', name: 'libIndex', component: () => import('@/views/shop/lib/index') },
        { meta: { shareEnabled: true }, path: '/shop/lib/libList', name: 'libList', component: () => import('@/views/shop/lib/libList') },
        { meta: { shareEnabled: true }, path: '/shop/lib/libInfo', name: 'libInfo', component: () => import('@/views/shop/lib/libInfo') },
        /* 直播课 */
        { meta: { shareEnabled: true }, path: '/shop/live', redirect: '/shop/live/index' },
        { meta: { shareEnabled: true }, path: '/shop/live/index', name: 'liveIndex', component: () => import('@/views/shop/live/index') },
        { meta: { shareEnabled: true }, path: '/shop/live/homeworkInfo', name: 'liveHomeworkInfo', component: () => import('@/views/shop/live/homeworkInfo') },
        { meta: { shareEnabled: true }, path: '/shop/live/classInfo', name: 'liveClassInfo', component: () => import('@/views/shop/live/classInfo') },
        /* 麦田君卡作文精批 */
        { path: '/shop/mtjCard/homeworkList', name: 'mtjCardHomeworkList', component: () => import('@/views/shop/mtjCard/homeworkList') },
        /* 录播打卡 */
        { meta: { shareEnabled: true }, path: '/shop/punchIn/punchInList', name: 'punchInList', component: () => import('@/views/shop/punchIn/punchInList') },
        { meta: { shareEnabled: true }, path: '/shop/punchIn/punchInRecordList', name: 'punchInRecordList', component: () => import('@/views/shop/punchIn/punchInRecordList') },
        { meta: { shareEnabled: true }, path: '/shop/punchIn/punchInRecordInfo', name: 'punchInRecordInfo', component: () => import('@/views/shop/punchIn/punchInRecordInfo') },
      ]
    },
    /* 同步作文 */
    { meta: { shareEnabled: true }, path: '/tbzw', redirect: '/tbzw/index' },
    { meta: { shareEnabled: true }, path: '/tbzw/index', name: 'tbzeIndex', component: () => import('@/views/tbzw/index') },
    { meta: { shareEnabled: true }, path: '/tbzw/homeworkSubmit', name: 'tbzeHomeworkSubmit', component: () => import('@/views/tbzw/homeworkSubmit') },
    { meta: { shareEnabled: true }, path: '/tbzw/homeworkInfo', name: 'tbzeHomeworkInfo', component: () => import('@/views/tbzw/homeworkInfo') },
    { meta: { shareEnabled: true }, path: '/tbzw/xrList', name: 'xrList', component: () => import('@/views/tbzw/xrList') },
    { meta: { shareEnabled: true }, path: '/tbzw/mgtvList', name: 'mgtvList', component: () => import('@/views/tbzw/mgtvList') },

    /* 临时页面 */
    { meta: { shareEnabled: true }, path: '/_demo/liveXiaHuaQiuShi', name: 'demoLiveXiaHuaQiuShi', component: () => import('@/views/_demo/liveXiaHuaQiuShi') }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 将请求参数Authorization保存到session
  if (to.query.Authorization) {
    Session.authorization = to.query.Authorization;
    Axios.get("/api/user/getUser", {
      params: {}
    }).then(res => {
      if (res.code !== 0) {
        next({ name: "error", params: { msg: "获取用户信息失败" } });
        return;
      }
      delete to.query.Authorization;
      Session.user = res.data;
      let url = to.path + "?a=1";
      for (const key in to.query) {
        url += "&" + key + "=" + to.query[key];
      }
      window.location = url;
    });
    return;
  }
  // 更新微信分享信息
  try {
    if (Global.wxShare.link === "") {
      Global.wxShare.link = window.location.origin + to.fullPath;
      if (to.fullPath.indexOf("operId=") === -1) {
        Global.wxShare.link += (Global.wxShare.link.indexOf("?") > 0 ? "&" : "?") + "operId=" + Session.user.operId;
      }
    }
    if (to.meta.shareEnabled === true) { WxJs.setShare(Global.wxShare, Global.domain + to.fullPath); }
    else { WxJs.hideAllMenu(); }
  } catch (e) { }
  next();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js